import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';


import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import WalletIcon from '@mui/icons-material/Wallet';
import { Box, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography, useTheme } from '@mui/material';
import AuthContext from '../../navigation/context/authContext';
import { Nfc, NfcRounded } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNfcSymbol } from '@fortawesome/free-brands-svg-icons';





export default function FinanceListItems(props){

    const { signOut } = useContext(AuthContext);

    const theme = useTheme();
    let history = useHistory();
    
    const redireccionar = (ruta) => {
        history.push(ruta);
    }

    const handleSignOut = () => {
        history.replace('/');
        signOut();
    }

    return(
        <div>
            {
                props.open &&
                <ListItem>
                    <Typography variant='body1' color={'#878787'} >Finanzas</Typography>
                </ListItem>
            }
            
            <ListItem button onClick={()=>redireccionar('/finances/banks')}>
                <Tooltip title='Mis Cuentas' placement='right'>
                    <ListItemIcon>
                        <AccountBalanceIcon sx={{color:'primary.contrastText'}}/>
                    </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Mis Cuentas" />
            </ListItem>
            
            {/*<ListItem button onClick={()=>redireccionar('/wallet')}>
                <ListItemIcon>
                    <WalletIcon sx={{color:'primary.contrastText'}}/>
                </ListItemIcon>
                <ListItemText primary="Billetera" />
            </ListItem>*/}
        </div>
    )    
}
    